export const SOFTWARE_PAGE_VIEWED_COOKIE = '_solidshop_software_page_viewed';

/** square one pnp experiment */
export const SQUARE_ONE_PNP_COOKIE = 'optly_var_square-one-pnp';
export const SQUARE_ONE_BUCKETED_VALUE = 'square-one-group-v1';
